import { render } from "./createUser.vue?vue&type=template&id=35a31cf1&scoped=true"
import script from "./createUser.vue?vue&type=script&lang=js"
export * from "./createUser.vue?vue&type=script&lang=js"

import "./createUser.vue?vue&type=style&index=0&id=35a31cf1&scoped=true&lang=scss"

import exportComponent from "/Users/home/Documents/kevin/migration_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35a31cf1"]])

export default __exports__